@let img = image();
@let isDefault = defaultImage();

@if (img && !isDefault) {
  <img
    [src]="img"
    (load)="onImageLoad()"
    (error)="onImageError()"
    ngpAvatarImage
    alt=""
    aria-hidden="true"
    decoding="async"
    [attr.loading]="loadType()"
    [class]="imageClass"
  />
} @else if (isDefault) {
  <ml-icon name="person" [size]="iconSize()"></ml-icon>
} @else {
  <span ngpAvatarFallback [ngpAvatarFallbackDelay]="fallbackDelay()" aria-hidden="true"> {{ fallback() }}</span>
}
